import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faCalendarCheck, faPhone } from '@fortawesome/free-solid-svg-icons';
import './Hero.css';

interface HeroProps {
  image?: string;
  name: string;
  specialty?: string;
  description: string;
  availability?: string;
  nextSlot?: string;
}

const Hero: React.FC<HeroProps> = ({
  image,
  name,
  specialty,
  description,
  availability,
  nextSlot
}) => {

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-image-wrapper">
          {image ? (
            <img src={image} alt={name} className="hero-image" />
          ) : (
            <div className="hero-image-placeholder">GM</div>
          )}
          {availability && nextSlot && (
            <div className="availability-badge">
              <FontAwesomeIcon icon={faClock} className="me-2" />
              <div>
                <div className="availability-title">{availability}</div>
                <div className="availability-time">{nextSlot}</div>
              </div>
            </div>
          )}
        </div>

        <div className="hero-content">
          {specialty && (
            <div className="specialty-badge">
              <span className="specialty-icon">🏥</span>
              <span>{specialty}</span>
            </div>
          )}

          <h1 className="hero-title">
            {name}
          </h1>

          <p className="hero-description">{description}</p>

          <div className="hero-buttons">
            <button className="btn-primary">
              <FontAwesomeIcon icon={faCalendarCheck} className="me-2" />
              Prenota una Visita
            </button>
            <a href="tel:+393701627395" className="btn-secondary">
              <FontAwesomeIcon icon={faPhone} className="me-2" />
              Chiama Ora
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
